module.exports = __webpack_public_path__ + "img/load_balancer-2.27270f74.webp";